import React from "react";
import moment from "moment";
import "moment/locale/bg";
import { useInput } from "react-admin";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";

const CustomDateTimeInput = props => {
  const {
    onChange,
    onBlur,
    label,
    validate,
    source,
    required = false,
    defaultValue,
    readOnly,
    disabled,
    minDate,
    maxDate,
    ...rest
  } = props;
  // Destructure field and formState from useInput hook
  const {
    field,
    fieldState: { isTouched, invalid, error },
    formState: { isSubmitted },
  } = useInput({
    onChange,
    onBlur,
    validate: [required],
    source,
    required,
    defaultValue,
    disabled,
    readOnly,
    ...props,
  });

  const handleChange = date => {
    if (date) {
      const changedValue = `${moment(date).format("YYYY-MM-DD")}T${date.format("HH:mm:ss")}`;
      field.onChange(changedValue);
    } else {
      field.onChange(null);
    }
  };

  const value = field?.value ? moment(field.value) : null;

  return (
    <LocalizationProvider
      dateAdapter={AdapterMoment}
      dateLibInstance={moment.utc}
      adapterLocale="bg"
    >
      <DateTimePicker
        {...field}
        label={props.label}
        format="DD-MM-YYYY H:mm"
        value={value}
        source={source}
        onChange={handleChange}
        minDate={minDate ? moment(minDate) : undefined}
        maxDate={maxDate ? moment(maxDate) : undefined}
        onBlur={onBlur}
        readOnly={readOnly}
        disabled={readOnly}
        error={(isTouched || isSubmitted) && invalid}
        helperText={(isTouched || isSubmitted) && invalid ? error : ""}
        isRequired={required}
        validate={validate}
        slotProps={{
          actionBar: {
            actions: ["clear"],
          },
          textField: {
            helperText: invalid ? error?.message?.replace(/@@react-admin@@/, "").replace(/^"|"$/g, "") : "",
            label: required ? props.label + " *" : props.label,
            error: invalid,
            InputProps: {
              style: {
                color: invalid ? "#9D1B53;" : "",
              },
            },
          },
        }}
        {...rest}
      />
    </LocalizationProvider>
  );
};

export default CustomDateTimeInput;
